<template>
  <div class="section__inner section__inner--noRightpad section__inner--noLeftpad">
    <div class="section__box section__box--smToppad">
      <div class="section__head">
        <h2 class="box-title">{{ title }}</h2>
        <div class="item-img">
          <router-link
            :to="{
              name: 'ProductCategory',
              params: { type: currentType, title, id: categoryid }
            }"
            class="btn--outline btn--sm"
            :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign' : '']"
          >
            {{ $t('button.seemore') }}
          </router-link>
        </div>
      </div>

      <!-- Swiper v11 for Vue -->
      <Swiper
        class="swiper carousel-wrapper carousel-wrapper--nopad"
        v-bind="swiperProps"
      >
        <SwiperSlide
          v-for="item in products"
          :key="item.product_id"
          :class="isBookType ? 'carousel-item card--v1 card--ebook' : 'carousel-item card--v1'"
        >
          <router-link
            :to="{
              name: 'ProductDetails',
              params: { type: helpers.portal_name, productId: item.product_id }
            }"
            @click="onProductClick($event, {
              name: 'ProductDetails',
              params: { type: helpers.portal_name, productId: item.product_id }
            })"
          >
            <div>
              <div class="item-img">
                <img :src="item.icon_small" :alt="item.title" />
              </div>
              <div class="item-data">
                <h3 class="data-title">{{ item.title }}</h3>
                <div class="data-category">
                  {{ item.short_description }}
                </div>
              </div>
            </div>
          </router-link>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex'

// Swiper v11 (Vue)
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// App helpers
import { helpers } from '../helper/portal_config'
import EventBus from '../helper/event_bus' // ensure this is Vue 3 friendly (see note below)

export default {
  name: 'CarouselA',
  props: {
    products: { type: Array, required: true },
    title: { type: String, required: true },
    categoryid: { type: [String, Number], required: true }
  },
  components: { Swiper, SwiperSlide },
  data() {
    return {
      helpers: '',
      currentType: null,
      currentLanguage: '',
      swiperProps: {
        modules: [Navigation, Pagination, Autoplay],
        loop: false,
        slidesPerView: 1.8,
        spaceBetween: 15,
        slidesOffsetAfter: 20,
        breakpoints: {
          400: { slidesPerView: 2.1 },
          667: { slidesPerView: 3.2, spaceBetween: 15 },
          767: { slidesPerView: 3.5, spaceBetween: 20 },
          1200: {
            slidesOffsetAfter: 0,
            grabCursor: false,
            touchRatio: 0,
            slidesPerView: 7
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({ isLoggedIn: 'globals/isLoggedIn' }),
    isBookType() {
      return this.helpers.portal_name === 'Carefizz'
    }
  },
  methods: {
    onProductClick(e, link) {
      if (!this.isLoggedIn) {
        EventBus.$emit?.('SHOW_SIGNIN_MODAL', link) || EventBus.emit?.('SHOW_SIGNIN_MODAL', link)
      }
    },
    getProductType() {
      const menu = this.helpers.menu || []
      menu.forEach((item) => {
        if (item.isActive === true) this.currentType = item.type
      })
    },
    setCurrentLanguage() {
      const { host } = window.location
      const country = host.split('.')[0].slice(0, 2).toUpperCase()
      const map = helpers.countryDefaultLanguage || {}
      this.currentLanguage = (map.hasOwnProperty(country) ? map[country] : country).toUpperCase()
    }
  },
  created() {
    this.helpers = helpers
    this.productSizes = 7
    this.getProductType()
    this.setCurrentLanguage()
  }
}
</script>

<style scoped>
.card--v1 .item-img {
  height: 42vw;
}
.card--v1 .item-img img {
  object-fit: contain;
  object-position: left;
  border-radius: 0;
}
.card--v1.card--ebook .item-img {
  height: 150px;
}
.card--v1.card--ebook .item-img img {
  object-fit: contain;
  object-position: left;
  border-radius: 0;
}
@media (min-width: 670px) {
  .card--v1 .item-img {
    height: 200px;
  }
}
@media (min-width: 1280px) {
  .card--v1.card--ebook .item-img {
    height: 150px;
  }
  .card--v1 .item-img {
    height: 12vw;
  }
}
@media (min-width: 1440px) {
  .card--v1.card--ebook .item-img {
    height: 200px;
  }
}
@media (min-width: 1600px) {
  .card--v1.card--ebook .item-img {
    height: 230px;
  }
}
@media (min-width: 1921px) {
  .card--v1.card--ebook .item-img {
    height: 260px;
  }
}
</style>
